const React = require("react");
const {Document, Text, Font} = require("@react-pdf/renderer");

const styles = require('./styles/');

const Page = require('./components/PageTemplate');
const SectionTitle = require('./components/SectionTitle');
const Section = require('./components/Section');
const SupportingDocumentsSection = require('./components/SupportingDocumentsSection');

Font.register({ family: 'HelveticaNow', fonts: [
    {src: require('../../../../../assets/fonts/HelveticaNowText/HelveticaNowText-Regular.ttf')},
    {src: require('../../../../../assets/fonts/HelveticaNowText/HelveticaNowText-Bold.ttf'), fontWeight: 700}
  ]
});

module.exports = (props) => {
  const data = (props.data || {});

  const company = (data.company || {}).company || {};
  const {
    company_name,
    reg_number,
    register_address,
    register_street,
    register_zip,
    register_city,
    register_country,

    operating_address,
    operating_street,
    operating_zip,
    operating_country,
    operating_city,

    link_company_details,
    nature
  } = company;

  const profile = (data.profile || {}).profile || {};

  const {
    director = {},
    holder = {},
    im_director
  } = profile;

  const owners = (data.owner || {}).list || {};

  const supportingDocuments = (data.document || {}).list || [];

  const bank = (data.bank || {}).bank || {};

  console.log(styles);

  return (
    <Document>
      <Page>
        <SectionTitle index="1" title="Company" />
        <Section
          items={[
            {title: 'Company Name', value: company_name},
            {title: 'Business Registration Number', value: reg_number},
            {title: 'Web', value: link_company_details || '-'},
            {title: 'Nature of business', value: nature || '-'}
          ]}
        />
        <Section
          subtitle="Business Address"
          items={[
            {title: 'Business Address', value: [register_street, register_address, register_zip]},
            {title: 'City and Country', value: [register_country, register_city].join(', ')}
          ]}
          additionalStyles={{marginTop: 6}}
          withBorder
        />
        <Section
          subtitle="Operating Address"
          items={[
            {title: 'Business address', value: [operating_street, operating_address, operating_zip]},
            {title: 'City and Country', value: [operating_country, operating_city].join(', ')}
          ]}
          additionalStyles={{marginTop: 6}}
          withBorder
        />
        <SectionTitle index="2" title="Personal profile" />
        <Section
          subtitle={im_director ? "Account Holder / Director" : "Account Holder"}
          items={[
            {title: 'Full Name', value: holder.full_name},
            {title: 'Date of Birth', value: holder.birthday},
            {title: 'Country of Residence', value: holder.country_of_residence},
            {title: 'Country of Birth', value: holder.country_of_birth},
            {title: 'Document Type', value: holder.document_type}
          ]}
          additionalStyles={{marginTop: 25}}
          withBorder
        />
        <SupportingDocumentsSection
          documents={[holder.document_address, holder.document_identity]}
          additionalStyles={{marginTop: 6}}
        />
        {!im_director && (
          <>
            <Section
              subtitle="Director"
              items={[
                {title: 'Full Name', value: director.full_name},
                {title: 'Date of Birth', value: director.birthday},
                {title: 'Country of Residence', value: director.country_of_residence},
                {title: 'Country of Birth', value: director.country_of_birth},
                {title: 'Document Type', value: director.document_type}
              ]}
              additionalStyles={{marginTop: 6}}
              withBorder
            />
            <SupportingDocumentsSection
              documents={[director.document_address, director.document_identity]}
              additionalStyles={{marginTop: 6}}
            />
          </>
        )}
      </Page>
      <Page>
        <SectionTitle index="3" title="Business owners" />
        {owners.length
          ? owners.map((owner, id) => (
            <React.Fragment key={id + 1}>
              <Section
                subtitle={`${id + 1} / UBO / Shareholder`}
                items={[
                  {title: 'Full Name', value: owner.full_name},
                  {title: 'Date of Birth', value: owner.date_of_birth},
                  {title: 'Country of Residence', value: owner.country_of_residence},
                  {title: 'Country of Birth', value: owner.country_of_birth},
                  {title: 'Document Type', value: owner.passport_or_nation_id},
                  {title: '% of Shares ', value: `${owner.owner_percent}%`}
                ]}
                additionalStyles={{marginTop: id === 0 ? 25 : 6}}
                withBorder
              />
              <SupportingDocumentsSection
                documents={[owner.document_address, owner.document_identity]}
                additionalStyles={{marginTop: 6}}
              />
            </React.Fragment>
          )) : (
            <Section
              subtitle="1 / UBO / Shareholder"
              items={[
                {title: 'Not Set', hideValue: true}
              ]}
              additionalStyles={{marginTop: 25}}
              withBorder
            />
          )
        }
        <SectionTitle index="4" title="Supporting documents" />
        <SupportingDocumentsSection
          documents={supportingDocuments}
          additionalStyles={{marginTop: 25}}
        />
        <SectionTitle index="5" title="Bank details" />
        <Section
          items={[
            {title: 'Primary Payout currency', value: bank.fiat_code},
            {title: 'IBAN / Account Number', value: bank.iban},
            {title: 'Bank Name', value: bank.name},
            {title: 'Swift Code', value: bank.swift},
            {title: 'Business address', value: bank.address}
          ]}
        />
      </Page>
    </Document>
  );
}
